import { render, staticRenderFns } from "./ZvSimpleTable.vue?vue&type=template&id=65417a8a&scoped=true&"
import script from "./ZvSimpleTable.vue?vue&type=script&lang=js&"
export * from "./ZvSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./ZvSimpleTable.vue?vue&type=style&index=0&id=65417a8a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65417a8a",
  null
  
)

export default component.exports